import { Card } from "react-bootstrap";
import { Link } from "react-router-dom";
import React from "react";
import { formattedPrice } from "../../../utils";

const DashboardCard = (props) => {
  const { number, title, color, icon, link, linkName } = props || {};

  return (
    <div className="dashboard-card card-animated">
      <Card>
        <Card.Body>
          <div className="dashboard-card-item-holder">
            <div className="dashboard-card-item">
              <div className="dashboard-card-item-title">{title}</div>
              <div className="dashboard-card-item-main">
                <div className="dashboard-card-item-content">
                  <div className="dashboard-card-item-content-number">
                    {number}
                  </div>
                  <div className="dashboard-card-item-content-link">
                    <Link to={link}>{linkName}</Link>
                  </div>
                </div>
                <div className="dashboard-card-item-icon">
                  <div className={`dashboard-card-item-icon-holder ${color}`}>
                    {icon}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Card.Body>
      </Card>
    </div>
  );
};

export default DashboardCard;
